import { Splide } from '@splidejs/splide';
import { initCustomSelects } from '../helpers/custom-select';

document.addEventListener('DOMContentLoaded', () => {
    initCustomSelects();
});


// js-hero-card

document.querySelectorAll('.js-hero-card').forEach(trigger => {
    trigger.addEventListener('click', () => {
        // climb up to the .hero-card wrapper
        const heroCard = trigger.closest('.hero-card');
        // grab the .hero-card__wrapper inside that card
        const wrapper  = heroCard.querySelector('.hero-card__wrapper');
        // toggle the expanded class

        trigger.classList.toggle('expanded');
        wrapper.classList.toggle('expanded');
    });
});

if (document.querySelector('.js-game-hero-slider')) {
    const slides        = document.querySelectorAll('.js-hero-card');
    const popularSlide  = document.querySelector('.js-hero-card.popular');
    const startIndex   = Array.prototype.indexOf.call(slides, popularSlide);
    const initialIndex = startIndex >= 0 ? startIndex : 0;


    const slider = new Splide('.js-game-hero-slider', {
        type: 'loop',
        perPage: 1,
        perMove: 1,
        arrows: false,
        gap: '1.5rem',
        pagination: false,
        padding: {right: '10%', left: '10%'},
        start: initialIndex,
    });


    // 2) Build your custom dots
    const container = document.querySelector( '.pagination' );
    const indices   = container.querySelector( '.indices' );

    // A shared function to:
    //  • position the SVGs (i1…iN)
    //  • flip for backward navigation
    //  • mark the active dot
    let prev = initialIndex;
    function updatePagination( newIdx ) {
        // Reset Pac-Man
        container.className = 'pagination';
        void container.offsetWidth;

        // Position the “mouth” and trigger animation
        container.classList.add( 'open', `i${ newIdx + 1 }` );
        if ( prev > newIdx ) {
            container.classList.add( 'flip' );
        }
        prev = newIdx;

        // Highlight active dot
        indices.querySelectorAll('.index').forEach((btn,i) => {
            btn.classList.toggle( 'active', i === newIdx );
        });
    }

    // On mount, set up initial state…
    slider.on( 'mounted', () => {
        updatePagination( slider.index );
    });

    // …and on every move, update it again
    slider.on( 'moved', newIdx => {
        updatePagination( newIdx );
    });

    slider.mount();
    // Build the buttons
    for ( let i = 0; i < slider.length; i++ ) {
        const btn = document.createElement( 'div' );
        btn.className   = 'index';
        btn.textContent = i + 1;
        btn.addEventListener( 'click', () => slider.go( i ) );
        indices.appendChild( btn );
    }
}

document.querySelectorAll('.js-see-more-features').forEach(trigger => {
    trigger.addEventListener('click', () => {
        const parent = trigger.closest('.js-hero-card-wrap');
        const list = parent.querySelector('.js-hidden-features');
        list.classList.toggle('active');
        trigger.classList.toggle('hidden');
    });
})





